import React, { useState } from "react";
import { Image, Spin } from "antd";

const CardImageItem = ({ fileName }) => {
  const [loading, setLoading] = useState(true);

  const handleImageLoad = () => setLoading(false);
  const handleImageError = () => setLoading(false);

  if (!fileName) {
    return (
      <h4 className="text-center"> Pas d'image 😑 </h4>
    );
  }

  return (
    <div className="image-container" style={{ position: "relative", textAlign: "center" }}>
      {loading && (
        <div className="loading-spinner mt-3">
          <p>Chargement, merci de patienter...</p>
          <Spin size="large" className="text-center" />
        </div>
      )}

      <Image
        src={`${process.env.REACT_APP_API_MEDIA_URL}/print/${fileName}`}
        alt="Image"
        className="img-fluid"
        onLoad={handleImageLoad}
        onError={handleImageError}
        style={{
          display: loading ? "none" : "block",
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
      />
    </div>
  );
};

export default CardImageItem;
